var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29303 13.2069C1.10556 13.0194 1.00024 12.7651 1.00024 12.4999C1.00024 12.2348 1.10556 11.9804 1.29303 11.7929L6.29303 6.79292C6.48163 6.61076 6.73423 6.50997 6.99643 6.51224C7.25863 6.51452 7.50944 6.61969 7.69485 6.8051C7.88026 6.99051 7.98543 7.24132 7.9877 7.50352C7.98998 7.76571 7.88919 8.01832 7.70703 8.20692L4.41403 11.4999H22C22.2652 11.4999 22.5196 11.6053 22.7071 11.7928C22.8947 11.9803 23 12.2347 23 12.4999C23 12.7651 22.8947 13.0195 22.7071 13.207C22.5196 13.3946 22.2652 13.4999 22 13.4999H4.41403L7.70703 16.7929C7.80254 16.8852 7.87872 16.9955 7.93113 17.1175C7.98354 17.2395 8.01113 17.3707 8.01228 17.5035C8.01344 17.6363 7.98813 17.768 7.93785 17.8909C7.88757 18.0138 7.81332 18.1254 7.71943 18.2193C7.62553 18.3132 7.51388 18.3875 7.39098 18.4377C7.26809 18.488 7.13641 18.5133 7.00363 18.5122C6.87085 18.511 6.73963 18.4834 6.61763 18.431C6.49562 18.3786 6.38528 18.3024 6.29303 18.2069L1.29303 13.2069Z",
    fill: "#4A4A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.6c299d6cdf367813a38a6af0cd6a2d3f.svg";
export { ForwardRef as ReactComponent };